/**
 * API utilities and Google Sheets configuration
 * Extracted from index.html monolith
 */

export const SCOPES = 'https://www.googleapis.com/auth/spreadsheets';
export const DISCOVERY_DOC = 'https://sheets.googleapis.com/$discovery/rest?version=v4';

/**
 * Retry API calls with exponential backoff
 * From reliability enhancements in 04-03
 *
 * @param {Function} apiCall     - the gapi call to attempt
 * @param {number}   maxRetries
 * @param {number}   initialDelay
 * @param {Function} [onAuthError] - async callback invoked once on a 401/403
 *   (e.g. to silently refresh the OAuth token) before retrying the call. If
 *   omitted, or if it throws, the original auth error is re-thrown as before.
 */
export const retryAPICall = async (apiCall, maxRetries = 3, initialDelay = 1000, onAuthError) => {
  let lastError;
  let authRetried = false;
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await apiCall();
    } catch (error) {
      lastError = error;
      const isAuthError = error?.status === 401 || error?.status === 403;
      if (isAuthError) {
        if (onAuthError && !authRetried) {
          authRetried = true;
          try {
            await onAuthError();
          } catch {
            throw error; // refresh failed — surface the original auth error
          }
          // Refund this attempt so the post-refresh retry always runs — even
          // when the 401 landed on the final iteration (otherwise `continue`
          // would exit the loop and throw the now-stale error). authRetried
          // caps this to one refund, so the loop can't spin.
          attempt--;
          continue;
        }
        throw error;
      }
      // Exponential backoff
      if (attempt < maxRetries - 1) {
        const delay = initialDelay * Math.pow(2, attempt);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }
  throw lastError;
};
